// Frontend copy of the backend's profanity blocklist. Kept in sync manually —
// when you add entries here, add them to backend/utils/profanityFilter.js too.
// See that file for the reasoning behind word-based (not substring) matching.

const BLOCKED_WORDS = new Set([
  // English
  "fuck", "fucker", "fucking", "fuk", "fck", "motherfucker",
  "shit", "shite", "shitty", "bullshit",
  "bitch", "biatch", "bitches",
  "cunt", "cunts",
  "dick", "dicks", "cock", "cocks",
  "pussy", "pussies",
  "asshole", "arsehole", "assholes",
  "bastard", "bastards",
  "whore", "whores", "hoe", "hoes",
  "slut", "sluts",
  "sexy", "sexi", "sexxy", "horny",
  "nude", "nudes", "naked",
  "porn", "porno", "pornhub", "xxx", "xnxx",
  "sex", "sexo",
  "boobs", "titties", "boobies",
  "penis", "vagina",
  "nigger", "nigga", "niggers",
  "faggot", "faggots", "fag",
  "retard", "retarded",
  "nazi", "hitler",
  "rape", "rapist",

  // Spanish
  "puta", "putas", "putos", "puto",
  "mierda", "mierdas",
  "joder", "jodete",
  "coño", "cono", "conyo",
  "verga", "vergas",
  "pinga", "pingas",
  "tetas", "teta",
  "culo", "culos",
  "gilipollas", "gilipollez",
  "cabron", "cabrón", "cabrones",
  "marica", "maricon", "maricón", "maricones",
  "follar", "follame",
  "chinga", "chingar", "chingada", "pendejo", "pendeja",

  // Arabic transliterated
  "sharmoota", "sharmota", "sharmuta",
  "ahba", "ahbah",
  "khara", "khra",
  "kus", "kos",
  "zubr", "zib", "zeb",
  "manyak", "manyaka",
  "wesekh", "wisikh",
]);

const normalizeToken = (token) =>
  String(token || "")
    .toLowerCase()
    .replace(/[^\p{L}]/gu, "");

export const containsProfanity = (text) => {
  if (!text) return false;
  return String(text)
    .split(/\s+/)
    .some((token) => BLOCKED_WORDS.has(normalizeToken(token)));
};
